import type { EventoOS, StatusOrdemServico } from '@/types/ordemServico';

/** Reabertura "ativa" a mostrar no detalhe da OS. */
export interface ReaberturaAtiva {
  motivo: string;
  por?: string; // nome de quem reabriu
  em: string; // ISO de criado_em
}

const ESTADOS_ATIVOS: ReadonlySet<StatusOrdemServico> = new Set([
  'pendente',
  'aceita',
  'em_execucao',
]);

/**
 * Deriva, a partir do audit trail, a reabertura a exibir ao prestador.
 * - Só quando a OS está de novo num estado ativo (pendente/aceita/em_execucao);
 *   se foi reconcluída/cancelada, retorna null (o banner some sozinho).
 * - Usa o evento `os_reaberta` mais recente (por criado_em).
 * - Sem motivo (ou só espaços) → null (não mostra banner vazio; cobre OS
 *   legadas reabertas antes de o motivo ser obrigatório).
 */
export function getReaberturaAtiva(
  eventos: EventoOS[] | undefined,
  statusAtual: StatusOrdemServico,
): ReaberturaAtiva | null {
  if (!eventos || eventos.length === 0) return null;
  if (!ESTADOS_ATIVOS.has(statusAtual)) return null;

  let maisRecente: EventoOS | null = null;
  for (const ev of eventos) {
    if (ev.tipo !== 'os_reaberta') continue;
    if (maisRecente === null || ev.criado_em > maisRecente.criado_em) {
      maisRecente = ev;
    }
  }
  if (maisRecente === null) return null;

  const motivoRaw = maisRecente.detalhes?.motivo;
  const motivo = typeof motivoRaw === 'string' ? motivoRaw.trim() : '';
  if (motivo === '') return null;

  return {
    motivo,
    por: maisRecente.usuario?.nome,
    em: maisRecente.criado_em,
  };
}
